import { MetaTagsProp } from '@web/components/Document/MetaTags'
import { PageOwner } from '@web/hooks/usePageInfo'
import { DEFAULT_USER_NICKNAME, MYPLACE_OFFICIAL_IDNO } from '@web/libs/constants'

export const getOGTag = (pageOwner?: PageOwner): MetaTagsProp => {
  const userProfileImage = pageOwner?.profile.originImageUrl ? { url: pageOwner.profile.originImageUrl } : null

  if (pageOwner?.idno === MYPLACE_OFFICIAL_IDNO) {
    return {
      title: '네이버 MY플레이스 공식 계정',
      description: '다양한 테마별 공간을 소개해 드려요',
      ...(userProfileImage && { image: userProfileImage }),
    }
  }

  if (pageOwner?.isThemeContentProvider) {
    return {
      title: `${pageOwner.profile.nickname} 공식 계정`,
      description: pageOwner.profile.introduction,
      ...(userProfileImage && { image: userProfileImage }),
    }
  }

  if (pageOwner?.profile.nickname)
    return {
      title: `${pageOwner.profile.nickname}님의 MY플레이스`,
      description: pageOwner.profile.introduction,
      ...(userProfileImage && { image: userProfileImage }),
    }

  return {
    title: `${DEFAULT_USER_NICKNAME}님의 MY플레이스`,
  }
}
